function Zambia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2564)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#496E2D"/>
  <path d="M22.2609 16H16V32C17.8702 32 19.6651 31.6781 21.3333 31.0884L22.2609 16Z" fill="#D80027"/>
  <path d="M26.6666 27.9246C29.9396 24.9949 32 20.7383 32 16H25.7391L26.6666 27.9246Z" fill="#FF9811"/>
  <path d="M21.3333 16V31.0884C23.3206 30.3858 25.1277 29.3021 26.6666 27.9246V16H21.3333Z" fill="black"/>
  <path d="M29.5652 10.4343H25.3913C25.3913 9.66591 24.7683 9.04297 23.9999 9.04297C23.2316 9.04297 22.6086 9.66591 22.6086 10.4343H18.4347C18.4347 11.2027 19.104 11.8256 19.8723 11.8256H19.826C19.826 12.594 20.4488 13.2169 21.2173 13.2169C21.2173 13.9853 21.8401 14.6082 22.6086 14.6082H25.3913C26.1596 14.6082 26.7826 13.9853 26.7826 13.2169C27.5509 13.2169 28.1739 12.594 28.1739 11.8256H28.1276C28.8959 11.8255 29.5652 11.2027 29.5652 10.4343Z" fill="#FF9811"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Zambia;
